import { Component, OnInit } from '@angular/core';
import { RequestService } from '../../../core/services/request.service';
import { Request } from '../../../core/models/request.model';
import { NewRequest } from '../../../core/models/new-request.model';
import { finalize } from 'rxjs/operators';
import { NotificationsService } from 'angular2-notifications';
import { InitializationService } from '../../../core/services/initialization.service';
import { ComponentMessengerService } from '../../../core/services/component-messenger.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { FormsModule } from '@angular/forms';
import { ClipboardModule } from 'ngx-clipboard';

@Component({
    selector: 'app-modal-new-request',
    templateUrl: './modal-new-request.component.html',
    styleUrls: ['./modal-new-request.component.scss'],
    imports: [InlineSVGComponent, FormsModule, ClipboardModule, TranslateModule],
})
export class ModalNewRequestComponent implements OnInit {
    isCreatingNewRequest = false;
    newRequest: NewRequest = new NewRequest();
    request: Request;

    constructor(
        public initializationService: InitializationService,
        private componentMessengerService: ComponentMessengerService,
        private modalRef: BsModalRef,
        private notificationsService: NotificationsService,
        private requestService: RequestService,
        private translateService: TranslateService,
    ) {}

    ngOnInit() {
        setTimeout(() => {
            document.getElementById('internalReference').focus();
        }, 0);
    }

    close(): void {
        this.modalRef.hide();
    }

    createRequest(): void {
        this.isCreatingNewRequest = true;

        this.requestService
            .addRequest({
                portalId: this.initializationService.portal.id,
                requestedBy: this.newRequest.requestedBy,
                internalReference: this.newRequest.internalReference,
            } as NewRequest)
            .pipe(
                finalize(() => {
                    this.isCreatingNewRequest = false;
                }),
            )
            .subscribe((request) => {
                this.request = request;
                this.componentMessengerService.requestCreated(true);
            });
    }

    showClipboardNotification(): void {
        this.notificationsService.success(
            this.translateService.instant('Success!'),
            this.translateService.instant('Copied to clipboard'),
        );
    }
}
